import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c3b0c4e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3b0c4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c3b0c4e')) {
      api.createRecord('1c3b0c4e', component.options)
    } else {
      api.reload('1c3b0c4e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1c3b0c4e&scoped=true", function () {
      api.rerender('1c3b0c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/withdraw/index.vue"
export default component.exports